export const APP_DIVIDER = {
  "Divider.Space.Around": {
    defaultValue: "default"
  },
  "Divider.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Divider.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Divider.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Divider.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Divider.Height.Type": {
    defaultValue: "fixed"
  },

  "Divider.Thickness": {
    defaultValue: "1px"
  },
  "Divider.Style": {
    defaultValue: "solid"
  },
  "Divider.Color": {
    ref: "Color.Gray.400"
  },

  "Divider.Content.Alignment": {
    defaultValue: "center"
  },

  "Divider.Content.Color": {
    ref: "Color.Gray.700"
  },
  "Divider.Content.Font.Size": {
    ref: "Font.Size.12"
  },
  "Divider.Content.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Divider.Content.Line.Height": {
    ref: "Line.Height.Base"
  },
  "Divider.Content.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Divider.Content.Font.Style": {
    defaultValue: "normal"
  },
  "Divider.Content.Text.Decoration": {
    defaultValue: "none"
  },

  "Divider.Padding.Top": {
    defaultValue: "4px"
  },
  "Divider.Padding.Right": {
    defaultValue: "4px"
  },
  "Divider.Padding.Bottom": {
    defaultValue: "4px"
  },
  "Divider.Padding.Left": {
    defaultValue: "4px"
  },

  "Divider.Horizontal.Width": {
    defaultValue: "100%"
  },
  "Divider.Horizontal.Max.Width": {
    defaultValue: "100%"
  },
  "Divider.Horizontal.Min.Width": {
    defaultValue: "1px"
  },
  "Divider.Horizontal.Height": {
    defaultValue: "auto"
  },
  "Divider.Horizontal.Min.Height": {
    defaultValue: "0px"
  },
  "Divider.Horizontal.Max.Height": {
    defaultValue: "unset"
  },

  "Divider.Vertical.Width": {
    defaultValue: "auto"
  },
  "Divider.Vertical.Max.Width": {
    defaultValue: "unset"
  },
  "Divider.Vertical.Min.Width": {
    defaultValue: "0px"
  },
  "Divider.Vertical.Height": {
    defaultValue: "100px"
  },
  "Divider.Vertical.Min.Height": {
    defaultValue: "1px"
  },
  "Divider.Vertical.Max.Height": {
    defaultValue: "100%"
  },

  "Divider.Margin.Top": {
    defaultValue: "0px"
  },
  "Divider.Margin.Right": {
    defaultValue: "0px"
  },
  "Divider.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Divider.Margin.Left": {
    defaultValue: "0px"
  },
  "Divider.Overflow": {
    defaultValue: "auto"
  },
  "Divider.Cursor": {
    defaultValue: "pointer"
  },
  "Divider.Box.Sizing": {
    defaultValue: "border-box"
  }
};
